import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'base' | 'raised' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  base: 'bg-night-800 text-ink',
  raised: 'bg-night-700 text-ink',
  deep: 'bg-night-900 text-ink'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'base',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-158" data-mp="2q4zuctjiujg">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-narrow' : 'max-w-content'}`} data-id="element-159" data-mp="2o0xw0f7c5lt">
        {hasHeader && <header className="mx-auto max-w-narrow text-center" data-id="element-160" data-mp="vcy24zmkw1vk">
            {eyebrow && <p className="mb-4 font-display text-xs font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-161" data-mp="106u0i36r7qr9">
                {eyebrow}
              </p>}
            {title && <h2 className="font-display text-[2rem] font-bold leading-[1.15] tracking-tight text-ink md:text-[2.75rem]" data-id="element-162" data-mp="2ums8fpeyfuhl">
                {title}
              </h2>}
            {intro && <p className="mx-auto mt-5 max-w-2xl text-lg text-muted" data-id="element-163" data-mp="33l480gxsu2m6">{intro}</p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-164" data-mp="3i9s0ufg9fy8f">{children}</div>
      </div>
    </section>;
}